var render = function render(){var _vm=this,_c=_vm._self._c;return _c('d-list-group',{attrs:{"flush":""}},[_c('d-list-group-item',{staticClass:"p-3"},[_c('h4',[_vm._v("\n      Oops! Você não tem permissão para estar aqui.\n      "),_c('i',{staticClass:"far fa-smile text-warning"})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }